// @core/stores/booking/BookingPolicyStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { bookingApi } from '@core/api';
import type {
  BookingPolicyResponse,
  ResolveBookingContextRequest,
  ResolveBookingContextResponse,
  UpsertPolicyRequest,
} from '@core/types/booking';

class BookingPolicyStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get effective policy
   */
  async GetEffectivePolicy(resource_id: string): Promise<BookingPolicyResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.GetEffectivePolicy(resource_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Resolve booking context
   */
  async ResolveBookingContext(data: ResolveBookingContextRequest): Promise<ResolveBookingContextResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.ResolveBookingContext(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Upsert booking policy
   */
  async UpsertPolicy(data: UpsertPolicyRequest): Promise<BookingPolicyResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.UpsertPolicy(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const bookingPolicyStore = new BookingPolicyStore();
